// extracted by mini-css-extract-plugin
module.exports = {"container":"TicketInformation_container_11HZR","template":"TicketInformation_template_4rGWW","link":"TicketInformation_link_1b2HW"};